<script setup lang="ts">
  import InfoIcon from '@/shared/assets/icons/Info.svg';
  import { IconImage } from '@/shared/ui';
  import { DIRECTORY_LEGEND_ITEMS, DIRECTORY_TYPE_ICONS } from '../config/directoryTypeIcons';

  const legendItems = DIRECTORY_LEGEND_ITEMS;
  const typeIcons = DIRECTORY_TYPE_ICONS;
</script>

<template>
  <section data-testid="directories-legend" class="rounded-xl border border-gray-03 bg-gray-08 p-4">
    <div class="flex items-center gap-1">
      <IconImage :src="InfoIcon" alt="Legenda" class="size-5 shrink-0 text-gray-03" />
      <span class="text-sm font-semibold text-gray-03">Legenda</span>
    </div>

    <!--
      Cada item mede o próprio conteúdo (flex-auto = base no conteúdo) e a sobra é dividida entre os
      cinco, então a faixa fecha 100% da largura sem virar cinco colunas iguais.
    -->
    <ul class="mt-2 flex min-h-10 flex-wrap items-stretch rounded-2xl border border-gray-02">
      <li
        v-for="item in legendItems"
        :key="item.iconId"
        class="flex flex-auto items-center gap-2 border-r border-gray-02 px-2 py-2 last:border-r-0"
      >
        <component
          :is="typeIcons[item.iconId]"
          class="size-5 shrink-0 text-gray-03"
          aria-hidden="true"
        />
        <span class="text-xs whitespace-nowrap text-gray-07">{{ item.label }}</span>
      </li>
    </ul>
  </section>
</template>
